import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const ProjectExpoPrakalp2025 = () => {
    const workshopImages = [
        "1.png ",
        "3.png ",
        "4.png ",
        "5.png ",
        "6.png ",
        "7.png",
    ];


    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        Project Expo – Prakalp 2025
                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            A One-day Project Expo was conducted for BTech IT- IV-I students participated and demonstrated their projects, which helped them to enhance their research, presentation, and communication skills.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Project-Expo-Prakalp-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Project-Expo-Prakalp-2025/${img}`}
                                                            alt={`Project Expo Prakalp 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ProjectExpoPrakalp2025;
